// extracted by mini-css-extract-plugin
export var changeIcon = "_79-4";
export var container = "_79-0";
export var divider = "_79-7";
export var externalLinkIcon = "_79-1";
export var green = "_79-5";
export var helpCircleIcon = "_79-3";
export var iconButton = "_79-2";
export var red = "_79-6";